import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Languages } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { supabase } from '@/integrations/supabase/client';
import { useEffect, useState } from 'react';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
      
      // If user is logged in, get their preferred language
      if (user) {
        const { data: customer } = await supabase
          .from('customers')
          .select('preferred_language')
          .eq('id', user.id)
          .single();
        
        if (customer?.preferred_language && customer.preferred_language !== i18n.language) {
          i18n.changeLanguage(customer.preferred_language);
        }
      } else {
        // For guests, check browser language and default to Italian unless German
        const browserLang = navigator.language.toLowerCase();
        const preferredLang = browserLang.startsWith('de') ? 'de' : 'it';
        
        // Check if there's a saved language preference
        const savedLang = localStorage.getItem('guest_language');
        const targetLang = savedLang || preferredLang;
        
        if (targetLang !== i18n.language) {
          i18n.changeLanguage(targetLang);
        }
      }
    };
    
    getUser();
  }, [i18n]);

  const changeLanguage = async (lng: string) => {
    i18n.changeLanguage(lng);
    
    // Save language preference for logged in users
    if (user) {
      await supabase
        .from('customers')
        .update({ preferred_language: lng })
        .eq('id', user.id);
    }
    
    // For guests, store in localStorage
    localStorage.setItem('guest_language', lng);
  };

  // Safe fallback for language display
  const currentLanguage = (i18n.language || 'it').substring(0, 2);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="text-primary hover:bg-primary/10">
          <Languages className="w-4 h-4 mr-2" />
          {currentLanguage.toUpperCase()}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-card border border-border z-[99999]">
        <DropdownMenuItem 
          onClick={() => changeLanguage('it')}
          className="cursor-pointer hover:bg-muted"
        >
          🇮🇹 Italiano
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => changeLanguage('de')}
          className="cursor-pointer hover:bg-muted"
        >
          🇩🇪 Deutsch
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};